"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DescendantManager = void 0;
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isFunction = require("./isFunction");
class DescendantManager {
  constructor({
    trapNode,
    getDescendantNodes,
    getActiveDescendantNode,
    firstKeyCode,
    previousKeyCode,
    nextKeyCode,
    lastKeyCode,
    pageUpKeyCode,
    pageDownKeyCode,
    ignoreFirstAndLastKeys,
    stepValue,
    stopKeyPressPropagation,
    onActiveDescendantChange
  }) {
    this.detach = () => {
      document.removeEventListener('keydown', this.keyHandler);
    };
    this.updateDescendantNodes = () => {
      this.descendantNodes = this.getDescendantNodes();
    };
    this.updateActiveDescendant = fn => {
      this.activeDescendant = (0, _isFunction.isFunction)(fn) ? fn() : null;
    };
    this.getIsFirstKey = event => event.keyCode === this.firstKeyCode;
    this.getIsPreviousKey = event => this.previousKeyCode.includes(event.keyCode);
    this.getIsNextKey = event => this.nextKeyCode.includes(event.keyCode);
    this.getIsLastKey = event => event.keyCode === this.lastKeyCode;
    this.getIsPageUpKey = event => event.keyCode === this.pageUpKeyCode;
    this.getIsPageDownKey = event => event.keyCode === this.pageDownKeyCode;
    this.keyHandler = e => {
      if (!document.body.contains(this.container)) {
        document.removeEventListener('keydown', this.keyHandler);
        return;
      }
      // first and last keys are only captured for standalone components
      const isFirstKey = !this.ignoreFirstAndLastKeys && this.getIsFirstKey(e);
      const isPreviousKey = this.getIsPreviousKey(e);
      const isNextKey = this.getIsNextKey(e);
      const isLastKey = !this.ignoreFirstAndLastKeys && this.getIsLastKey(e);
      const isPageUpKey = this.getIsPageUpKey(e);
      const isPageDownKey = this.getIsPageDownKey(e);
      if (isFirstKey || isPreviousKey || isNextKey || isLastKey || isPageUpKey || isPageDownKey) {
        e.preventDefault();
        if (this.stopKeyPressPropagation) {
          e.stopPropagation();
        }
        const currentIndex = this.descendantNodes.indexOf(this.activeDescendant);
        this.updateDescendantNodes();
        const lastNode = this.descendantNodes[this.descendantNodes.length - 1];
        const firstNode = this.descendantNodes[0];
        if (isFirstKey) {
          this.setActiveDescendant(e, firstNode);
        } else if (isPreviousKey) {
          if (currentIndex === -1) {
            this.setActiveDescendant(e, firstNode);
          } else if (this.descendantNodes[currentIndex] === firstNode) {
            if (this.ignoreFirstAndLastKeys) {
              this.setActiveDescendant(e, lastNode);
            }
          } else {
            this.setActiveDescendant(e, this.descendantNodes[currentIndex - 1]);
          }
        } else if (isNextKey) {
          if (currentIndex === -1) {
            this.setActiveDescendant(e, firstNode);
          } else if (this.descendantNodes[currentIndex] === lastNode) {
            if (this.ignoreFirstAndLastKeys) {
              this.setActiveDescendant(e, firstNode);
            }
          } else {
            this.setActiveDescendant(e, this.descendantNodes[currentIndex + 1]);
          }
        } else if (isLastKey) {
          this.setActiveDescendant(e, lastNode);
        } else if (isPageDownKey) {
          if (currentIndex === -1) {
            this.setActiveDescendant(e, firstNode);
          } else if (currentIndex + this.stepValue >= this.descendantNodes.length - 1) {
            this.setActiveDescendant(e, lastNode);
          } else {
            this.setActiveDescendant(e, this.descendantNodes[currentIndex + this.stepValue]);
          }
        } else if (isPageUpKey) {
          if (currentIndex === -1) {
            this.setActiveDescendant(e, firstNode);
          } else if (currentIndex <= this.stepValue) {
            this.setActiveDescendant(e, firstNode);
          } else {
            this.setActiveDescendant(e, this.descendantNodes[currentIndex - this.stepValue]);
          }
        }
      }
    };
    this.setActiveDescendant = (e, node) => {
      if (node) {
        const previousActiveDescendant = this.activeDescendant;
        this.activeDescendant = node;
        this.onActiveDescendantChange(e, node, previousActiveDescendant, this.descendantNodes);
      }
    };
    this.pageDownKeyCode = pageDownKeyCode || _keycode.default.codes.pgdn;
    this.pageUpKeyCode = pageUpKeyCode || _keycode.default.codes.pgup;
    this.container = trapNode;
    this.firstKeyCode = firstKeyCode || _keycode.default.codes.home;
    this.previousKeyCode = previousKeyCode || [_keycode.default.codes.up];
    if (!Array.isArray(this.previousKeyCode)) {
      this.previousKeyCode = [this.previousKeyCode];
    }
    this.nextKeyCode = nextKeyCode || [_keycode.default.codes.down];
    if (!Array.isArray(this.nextKeyCode)) {
      this.nextKeyCode = [this.nextKeyCode];
    }
    this.lastKeyCode = lastKeyCode || _keycode.default.codes.end;
    this.ignoreFirstAndLastKeys = !!ignoreFirstAndLastKeys;
    this.stepValue = stepValue || 5;
    this.stopKeyPressPropagation = !!stopKeyPressPropagation;
    this.onActiveDescendantChange = (0, _isFunction.isFunction)(onActiveDescendantChange) ? onActiveDescendantChange : () => {};
    this.getDescendantNodes = (0, _isFunction.isFunction)(getDescendantNodes) ? getDescendantNodes : () => [];
    this.updateDescendantNodes();
    if ((0, _isFunction.isFunction)(getActiveDescendantNode)) {
      this.activeDescendant = getActiveDescendantNode();
    }
    document.addEventListener('keydown', this.keyHandler);
  }
}
exports.DescendantManager = exports.default = DescendantManager;